import type { FunctionComponent } from 'react';

import Logo from 'assets/images/logo-soul-sanctuary-new-150px.svg';

import './style.scss';

const ForbiddenPage: FunctionComponent = () => (
  <div styleName="container">
    <Logo />
    <h1>Access Forbidden</h1>
  </div>
);

export default ForbiddenPage;
